import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SxProps, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// import UndoIcon from '@mui/icons-material/Undo';
import { isTmpId, useAPIWrapper } from 'drf-react-by-schema';

import { Layout } from '../styles';
import { useAppSelector } from '../app/hooks';

type FormButtonsProps = {
  cancelBtn?: (() => void) | null;
  sx?: SxProps<Theme>;
  bottom?: boolean;
  borderBottom?: boolean;
  saveAndContinue?: boolean;
  backTarget?: number;
};

export default function FormButtons({
  cancelBtn,
  sx: inputSx,
  bottom = false,
  borderBottom = true,
  saveAndContinue = false,
  backTarget = -1,
}: FormButtonsProps) {
  const { id: objId, model, isMobile, title, formDisabled } = useAppSelector((state) => state.page);
  const { onDeleteModel } = useAPIWrapper();
  const navigate = useNavigate();
  const sx: SxProps<Theme> =
    bottom && borderBottom && objId && objId !== 'novo'
      ? {
          ...Layout.flexRowGrow,
          mb: 5,
          pb: 2,
          borderBottom: 'solid 1px #aaa',
        }
      : { ...Layout.flexRowGrow };
  return (
    <Box sx={inputSx ? inputSx : sx}>
      {bottom ? (
        <Button
          variant="contained"
          type="button"
          color="error"
          size="small"
          disabled={isTmpId(objId) || !onDeleteModel}
          onClick={() => onDeleteModel?.(model || '', objId)}>
          Apagar
        </Button>
      ) : title && !isMobile ? (
        <Typography variant="h5">{title}</Typography>
      ) : (
        <Box />
      )}
      <Box sx={Layout.flexRow}>
        {cancelBtn ? (
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ ml: 1 }}
            onClick={cancelBtn}>
            Cancelar
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ ml: 1 }}
            onClick={() => {
              navigate(backTarget);
            }}>
            Voltar
          </Button>
        )}
        {!isMobile && saveAndContinue && (
          <>
            <Button
              variant="contained"
              name="createNewOnSave"
              type="submit"
              color="secondary"
              size="small"
              sx={{ ml: 1 }}
              disabled={formDisabled}>
              Salvar e criar novo
            </Button>
            <Button
              variant="contained"
              name="stayOnSave"
              type="submit"
              color="secondary"
              size="small"
              sx={{ ml: 1 }}
              disabled={formDisabled}>
              Salvar e continuar
            </Button>
          </>
        )}
        <Button
          variant="contained"
          type="submit"
          color="primary"
          size="small"
          sx={{ ml: 1 }}
          disabled={formDisabled}>
          Salvar
        </Button>
      </Box>
    </Box>
  );
}
